import React from 'react'
import PropTypes from 'prop-types'
import './Count.scss'

const Count = ({ page, total }) => (
  <div className="question-count">
    Question {page}/{total}
  </div>
)

Count.propTypes = {
  page: PropTypes.number.isRequired,
  total: PropTypes.number.isRequired
}

export default Count
